import styled from 'styled-components';
export const Title = styled.h6.withConfig({
  displayName: "Title",
  componentId: "sc-scixk0-0"
})(["padding:24px 14px 14px 14px;margin-top:12px;font-size:18px;font-weight:700;line-height:20px;color:", ";&:after{display:block;margin-top:10px;width:80%;height:1px;content:'';background-color:", ";}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.terciaryD;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.ui;
});